import React from "react"
import { Modal } from "@mui/material"
import { LuInfo } from "react-icons/lu"
import Button from "../../../components/Button/Button"

const ContactGroupInUseModal = ({ message, onClose }) => (
  <Modal open onClose={onClose}>
    <div className="flex items-center justify-center h-screen">
      <div
        role="dialog"
        aria-labelledby="contact-group-in-use-title"
        className="bg-paper rounded-2xl p-6 flex flex-col justify-between max-w-[480px] max-h-content"
      >
        <div className="mb-6 flex items-center">
          <LuInfo size={18} className="text-text-secondary" />
          <h4 id="contact-group-in-use-title" className="font-sans text-lg-18 ml-[18px] text-text-primary">Contact group in use</h4>
        </div>
        <div className="font-sans max-h-[503px] overflow-auto text-text-secondary">
          {message}
        </div>
        <div className="mt-6 flex justify-end">
          <Button onClick={onClose} size="md" width="w-max">OK</Button>
        </div>
      </div>
    </div>
  </Modal>
)

export default ContactGroupInUseModal
